<ul class="nav nav-tabs">
    <li class="nav-item">
        <a href="#" id="sale-buyer-link" data-toggle="tab" data-target="#sale-buyer-tab" class="nav-link active">{{words[language][ 'Buyer' ] }}</a>
    </li>
    @if (isUnLock && saleBuyer && saleBuyer.contactId && (!saleCoBuyers || (saleCoBuyers.length <= 0))) {
        <li class="nav-item cilckable" (click)="selectContact($event, COBUYER_ROLE)">
            <a href="#" id="sale-cobuyer-add-link" class="nav-link bg-light"><span class="dripicons-plus"></span></a>
        </li>
    }
    @if (saleBuyer && saleBuyer.contactId && saleCoBuyers && (saleCoBuyers.length > 0)) {
        <li class="nav-item">
            <a href="#" id="sale-cobuyer-link" data-toggle="tab" data-target="#sale-cobuyer-tab" class="nav-link">{{words[language][ 'Co-Buyer' ] }}</a>
        </li>
    }
    @if (isUnLock && saleBuyer && saleBuyer.contactId && saleCoBuyers && (saleCoBuyers.length > 0) && (!saleCoSigners || (saleCoSigners.length <= 0))) {
        <li class="nav-item clickable" (click)="selectContact($event, COSIGNER_ROLE)">
            <a href="#" id="sale-cosigner-add-link" class="nav-link bg-light"><span class="dripicons-plus"></span></a>
        </li>
    }
    @if (saleBuyer && saleBuyer.contactId && saleCoSigners && (saleCoSigners.length > 0)) {
        <li class="nav-item">
            <a href="#" id="sale-cosigner-link" data-toggle="tab" data-target="#sale-cosigner-tab" class="nav-link">{{words[language][ 'Co-Signer' ] }}</a>
        </li>
    }
</ul>

<div class="tab-content">
    <section class="tab-pane fade show active" id="sale-buyer-tab">
        @if (saleBuyer && saleBuyer.contactId) {
            <div class="card">
                <div class="card-body">
                    <div class="flexed">
                        <span class="material-icons">{{buyerIcon(saleBuyer.buyerType)}}</span>
                        <div>
                            <h4 class="clickable" (click)="editBuyer($event, saleBuyer.contactId)">
                                @if (saleBuyer.companyName) {
                                    <span>{{saleBuyer.companyName}}</span>
                                }
                                @else if (saleBuyer.lastName && saleBuyer.firstName) {
                                    <span>{{saleBuyer.lastName}}, {{saleBuyer.firstName}}</span>
                                }
                                @else {
                                    <span>{{saleBuyer.firstName}}</span>
                                }
                            </h4>
                            <form class="subtitle" [formGroup]="buyerEdit">
                                <select formControlName="saleBuyerTypeId">
                                    @for (buyerType of buyerTypes; track buyerType.id) {
                                        <option value="{{buyerType.id}}">{{buyerType.name}}</option>
                                    }
                                </select>
                            </form>
                        </div>
                    </div>
                    @if (saleBuyer.address) {
                        <div class="clickable" (click)="chooseAddress($event, saleBuyer.contactId)">
                            <div class="text-muted">
                                {{saleBuyer.address}} {{saleBuyer.address2}} {{saleBuyer.city}}, {{saleBuyer.state}} {{saleBuyer.zipCode}}
                            </div>
                            @if (saleBuyer.identificationNumber) {
                                <p class="ident subtitle" (click)="editBuyer($event, saleBuyer.contactId)">
                                    <span class="material-icons">{{identIcon(saleBuyer.identificationType)}}</span>
                                    <span>{{saleBuyer.identificationIssuer}} {{saleBuyer.identificationType}}</span>
                                    <span class="badge badge-{{expiryToClass(saleBuyer.identificationExpiration)}}">{{saleBuyer.identificationExpiration | date:'mediumDate'}}</span>
                                </p>
                            }
                        </div>
                        <div class="link-list">
                            @if (saleBuyer.email) {
                                <a href="mailto:{{saleBuyer.email}}">{{saleBuyer.email}}</a>
                            }
                            @if (saleBuyer.phoneNumber) {
                                <a href="tel:{{saleBuyer.phoneNumber}}">{{saleBuyer.phoneNumber | phone}}</a>
                            }
                        </div>
                    }
                    @if (isUnLock) {
                        <div class="actions">
                            @if (this.security.permitted('sales', 'buyers', 'delete')) {
                            <button class="btn btn-sm btn-link text-danger" data-toggle="modal" title="Discard"
                                data-target="#delete-modal-contact" (click)="deleteBuyerId = saleBuyer.id"
                                [disabled]="!isUnLock || saleCoBuyers.length > 0 || saleCoSigners.length > 0">
                                <span class="dripicons-trash"></span>
                            </button>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        @else if (!loading) {
            <datalist id="buyer-list">
                @for (buyer of matchedBuyers; track buyer.id) {
                    <option value="{{buyer.name}} {{buyer.city}}, {{buyer.state}}">{{buyer.name}} {{buyer.city}}, {{buyer.state}}</option>
                }
            </datalist>

            <div id="find-buyer" class="card">
                <div class="card-body">
                    <form [formGroup]="findBuyer">
                        <div class="input-group input-group-sm">
                            <div class="input-group-append">
                                <span class="input-group-text"><span class="material-icons">people</span></span>
                            </div>
                            <input autocomplete="off" type="search" class="form-control form-control-sm" id="search" autofocus="true" formControlName="inquiry" placeholder="Find a buyer" list="buyer-list" />
                            <div class="input-group-prepend">
                                <button class="btn btn-sm btn-primary"><span class="dripicons-plus" (click)="selectContact($event, BUYER_ROLE)"></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        }
    </section>

    @if (saleBuyer && saleBuyer.contactId && saleCoBuyers && (saleCoBuyers.length > 0)) {
        <section class="tab-pane fade" id="sale-cobuyer-tab">
            <ul class="list-group">
                @for (cobuyer of saleCoBuyers; track cobuyer) {
                    <li class="list-group-item">
                        <div data-target="#modal-contact-buyer" data-toggle="modal" class="meta" (click)="editBuyer($event, cobuyer.contactId)">
                            @if (!cobuyer.lastName && !cobuyer.firstName && cobuyer.companyName) {
                                <h3 id="companyName-{{cobuyer.id}}">{{cobuyer.companyName}}</h3>
                            }
                            @if (cobuyer.lastName || cobuyer.firstName) {
                                <h3 id="cobuyerName-{{cobuyer.id}}">{{cobuyer.lastName}}, {{cobuyer.firstName}}</h3>
                            }
                        </div>
                        <div class="text-muted" (click)="editBuyer($event, cobuyer.contactId)">{{cobuyer.address}}
                                {{cobuyer.address2}}<br />{{cobuyer.city}}, {{cobuyer.state}}
                                {{cobuyer.zipCode}}</div>
                        <div class="link-list">
                            @if (cobuyer.email) {
                                <a href="mailto:{{cobuyer.email}}">{{cobuyer.email}}</a>
                            }
                            @if (cobuyer.phoneNumber) {
                                <a href="tel:{{cobuyer.phoneNumber}}">{{cobuyer.phoneNumber | phone}}</a>
                            }
                        </div>
                        <div class="actions">
                            @if (isUnLock && this.security.permitted('sales', 'co-buyers', 'delete')) {
                                <button class="btn btn-sm text-danger" data-toggle="modal" title="Delete" data-target="#delete-modal-contact" (click)="deleteBuyerId = cobuyer.id" [disabled]="!isUnLock">
                                    <span class="dripicons-trash"></span>
                                </button>
                            }
                        </div>
                    </li>
                }
            </ul>
        </section>
    }

    @if (saleBuyer && saleBuyer.contactId && saleCoSigners && (saleCoSigners.length > 0)) {
        <section class="tab-pane fade" id="sale-cosigner-tab">
            <ul class="list-group">
                @for (cosigner of saleCoSigners; track cosigner) {
                    <li class="list-group-item">
                        <div data-target="#modal-contact-buyer" data-toggle="modal" class="meta" (click)="editBuyer($event, cosigner.contactId)">
                            @if (!cosigner.lastName && !cosigner.firstName && cosigner.companyName) {
                                <h3 id="companyName-{{cosigner.id}}">{{cosigner.companyName}}</h3>
                            }
                            @if (cosigner.lastName || cosigner.firstName) {
                                <h3 id="cosignerName-{{cosigner.id}}">{{cosigner.lastName}}, {{cosigner.firstName}}</h3>
                            }
                        </div>
                        <div class="text-muted" (click)="editBuyer($event, cosigner.contactId)">{{cosigner.address}}
                                {{cosigner.address2}}<br />{{cosigner.city}}, {{cosigner.state}}
                                {{cosigner.zipCode}}</div>
                        <div class="link-list">
                            @if (cosigner.email) {
                                <a href="mailto:{{cosigner.email}}">{{cosigner.email}}</a>
                            }
                            @if (cosigner.phoneNumber) {
                                <a href="tel:{{cosigner.phoneNumber}}">{{cosigner.phoneNumber | phone}}</a>
                            }
                        </div>
                        <div class="actions">
                            @if (this.security.permitted('sales', 'cosigners', 'delete')) {
                                <button class="btn btn-sm text-danger" data-toggle="modal" title="Delete" data-target="#delete-modal-contact" (click)="deleteBuyerId = cosigner.id" [disabled]="!isUnLock">
                                    <span class="dripicons-trash"></span>
                                </button>
                            }
                        </div>
                    </li>
                }
            </ul>
        </section>
    }
</div>

<!-- contact modal -->
<contact-modal [contactId]="editBuyerId" [key]="'buyer'" [words]="words" [language]="language" (modified)="contactModified($event)"></contact-modal>

<!-- delete modal -->
<div class="modal fade" id="delete-modal-contact" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h3 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h3>
                <span class="text-dark my-1 text-center">{{words[language][ 'deleteContact' ] }}</span>
                <button class="btn btn-danger mt-2" (click)="proceedWithDiscard()" data-dismiss="modal">{{words[language][ 'yes' ] }}</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-delete-contact">No</button>
            </div>
        </div>
    </div>
</div>

<!-- buyer selection and creation -->
<button type="button" id="btn-select-contact" class="d-none" data-target="#contact-list-modal" data-toggle="modal">&nbsp;</button>
<div class="modal fade" id="contact-list-modal" tabindex="-1" role="dialog" aria-labelledby="contactListModal"
    data-target="#modal">
    <div class="modal-dialog modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header text-dark">
                <h5 class="text-capitalize text-dark">Find/Add {{buyerRole ? buyerRole.name : 'Contact'}}</h5>
                <button type="button" class="close" id="btn-close-modal-contact-list" data-dismiss="modal" aria-label="Close" (click)="contactSelectorClosed($event)"><span>&times;</span></button>
            </div>
            <div class="modal-body">
                <contact-list [saleId]="saleId" [show]="displayContactSelector" (contactSelectedEvent)="contactSelected($event)"></contact-list>
            </div>
            <div class="modal-footer">
                <button class="btn btn-link" data-dismiss="modal" (click)="contactSelectorClosed($event)"><span class="text-muted">Cancel</span></button>
            </div>
        </div>
    </div>
</div>

<button id="btn-select-address-buyer-modal" data-target="#modal-select-address" data-toggle="modal" class="btn btn-sm text-dark d-none"></button>
<div class="modal fade" id="modal-select-address" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="addressChooserModal" data-keyboard="false">
    <div class="modal-dialog modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header text-dark">
                <h4>Choose Address</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span>&times;</span></button>
            </div>
            <div class="modal-body bg-gray">
                <address-chooser [contactId]="saleBuyer ? saleBuyer['contactId'] : 0"
                    [addressIdInUse]="saleBuyer ? saleBuyer['addressId'] : 0"
                    [locked]="!isUnLock" [isIndividual]="saleBuyer ? (saleBuyer.isIndividual || 1) : 1" [language]="language" [words]="words"
                    (addressSelected$)="listenEndpoint($event)"></address-chooser>
            </div>
            <div class="modal-footer">
                <button class="btn btn-link" data-dismiss="modal"><span class="text-muted">cancel</span></button>
            </div>
        </div>
    </div>
</div>